<script>
import Component, { mixins } from 'vue-class-component';
import WebPanelMixin from '@/core/shared/web-panel/WebPanelMixin';
import HealthCheckMixin from '@/core/shared/vuex-modules/health/HealthCheckMixin';

@Component()
export default class App extends mixins(WebPanelMixin, HealthCheckMixin) {
  hideNavMenu = true;

  get userOptions () {
    return [
      {
        name: this.$t('Operator Panel'),
        externalLink: `//${window.sbvrenv.OPERATOR_URL}`,
      },
    ];
  }
};
</script>
